module.exports = __webpack_public_path__ + "img/portugal-tuberculosis-male.a452f8d9.png";